import { useEffect } from "react";

/**
 * Runs an effect exactly once when the component mounts.
 * Accepts an optional cleanup function, just like `useEffect`.
 *
 * This is a semantic wrapper around `useEffect(fn, [])` that
 * silences the exhaustive-deps lint rule intentionally — the
 * empty dependency array is the desired behavior, not an oversight.
 *
 * Inspired by https://x.com/alvinsng/status/2033969062834045089
 *
 * @example
 * ```tsx
 * useMountEffect(() => {
 *   console.log("mounted");
 *   return () => console.log("unmounted");
 * });
 * ```
 */
export function useMountEffect(effect: () => void | (() => void)) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, []);
}
